import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'propertyVal'
})
export class PropertyValPipe implements PipeTransform {
	transform(propertyName: any, target: any): any {
		if (target.hasOwnProperty(propertyName) === true) {
			return target[propertyName];
		}
		return null;
	}

}
